export default __webpack_public_path__ + "static/media/Foundry.256.756c30ec.png";